module.exports = __webpack_public_path__ + "img/colaboracion.067177d2.jpeg";